module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cb-text cb-transition__fade--short cb-text--icon-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    ref: "password",
    staticClass: "cb-text__control cb-text__control--lg",
    class: {
      'cb-field__control--error': _vm.error && _vm.error.length > 0
    },
    style: (_vm.style),
    attrs: {
      "type": "password",
      "autocomplete": "off",
      "name": "password",
      "id": "password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "keyup": [function($event) {
        _vm.keyupCustom()
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.keyupEnter($event)
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "icon cb-text__icon cb-cursor--pointer",
    class: {
      'icon-eye': _vm.showPassword, 'icon-eye-closed': !_vm.showPassword
    },
    on: {
      "click": function($event) {
        _vm.toggleVisibility()
      }
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-150a8163"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/collections/form/PasswordField.vue
// module id = 433
// module chunks = 40 84